const MENU_BALANCE_LOAD_SUCCESS = 'MENU_BALANCE_LOAD_SUCCESS';

const MENU_BALANCE_LOAD_URL = '/common/menu/balance';

const REDUCER_MENU_BALANCE_NAME = 'menuBalance';

export {
  MENU_BALANCE_LOAD_SUCCESS,

  MENU_BALANCE_LOAD_URL,

  REDUCER_MENU_BALANCE_NAME,
};
